(() => {
  const splashPage = document.querySelector('[data-whynow-splash-page]');

  if (!splashPage) return;

  const isDesignMode =
    (window.Shopify && window.Shopify.designMode) ||
    document.documentElement.classList.contains('shopify-design-mode');

  const cookieName = splashPage.dataset.cookieName;
  const frequency = splashPage.dataset.frequency;
  const cookieDays = parseInt(splashPage.dataset.cookieDays, 10) || 1;
  const autoHideEnabled = splashPage.dataset.autoHide === 'true';
  const autoHideSeconds = parseInt(splashPage.dataset.autoHideSeconds, 10) || 1;
  const dialog = splashPage.querySelector('.whynow-splash-page__dialog');
  const video = splashPage.querySelector('video');
  let previouslyFocusedElement = null;
  let autoHideTimer = null;

  const hasCookie = () => document.cookie.split('; ').some((cookie) => cookie.startsWith(`${cookieName}=`));

  const setCookie = () => {
    if (frequency !== 'cookie') return;

    const expires = new Date();
    expires.setTime(expires.getTime() + cookieDays * 24 * 60 * 60 * 1000);
    document.cookie = `${cookieName}=true; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  };

  const showSplashPage = () => {
    splashPage.hidden = false;

    if (!isDesignMode) {
      previouslyFocusedElement = document.activeElement;
      document.body.classList.add('whynow-splash-page-open');
    }

    if (video) {
      video.muted = true;
      video.play().catch(() => {});
    }

    if (dialog && !isDesignMode) {
      dialog.focus({ preventScroll: true });
    }

    if (autoHideEnabled && !isDesignMode) {
      autoHideTimer = window.setTimeout(closeSplashPage, autoHideSeconds * 1000);
    }
  };

  const closeSplashPage = () => {
    if (autoHideTimer) {
      window.clearTimeout(autoHideTimer);
      autoHideTimer = null;
    }

    setCookie();
    splashPage.hidden = true;
    document.body.classList.remove('whynow-splash-page-open');

    if (video) video.pause();

    if (!isDesignMode && previouslyFocusedElement && typeof previouslyFocusedElement.focus === 'function') {
      previouslyFocusedElement.focus({ preventScroll: true });
    }
  };

  if (isDesignMode || frequency !== 'cookie' || !hasCookie()) {
    showSplashPage();
  }

  splashPage.querySelectorAll('[data-whynow-splash-page-close]').forEach((button) => {
    button.addEventListener('click', closeSplashPage);
  });

  splashPage.querySelectorAll('[data-whynow-splash-page-action]').forEach((link) => {
    link.addEventListener('click', setCookie);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !splashPage.hidden) closeSplashPage();
  });
})();
